export function showMyAppModules(organization, myAppModules) {
    var _a, _b;
    return Boolean(((_a = organization === null || organization === void 0 ? void 0 : organization.my_giving) === null || _a === void 0 ? void 0 : _a.enabled) ||
        ((_b = organization === null || organization === void 0 ? void 0 : organization.my_church_profile) === null || _b === void 0 ? void 0 : _b.enabled) ||
        myAppModules.length);
}
